import { Component, Input, OnInit } from '@angular/core';
import { State,Screen, Feature } from '../../../models/common';
import { Subject } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-select-screens-modal',
  templateUrl: './select-screens-modal.component.html',
  styleUrls: ['./select-screens-modal.component.scss']
})
export class SelectScreensModalComponent implements OnInit {
 IsDirty:boolean=false;
  selectScreens: boolean = true;
  //screensList: any = [];
  module:string="";
  screens: Feature[] = [];
  selectedScreens: Feature[] = [];
  action: Subject<any> = new Subject();

  @Input() public Content: any; 
  constructor(public modalRef: NgbActiveModal,private modalService: NgbModal,private commonService:CommonService) { }
  ngOnInit() {
    this.screens=this.Content.screens;
  }

  listSorted(event:any){
    this.IsDirty=true;
  }
  ScreenChange()
  {
    this.IsDirty=true;
  }
  save() {
    let isInvalid = false;
    let featureCodes = "IST14,IST15,IST16,IST17,IST18,IST19";
    let ScreenNotFeature = this.screens.filter((item) => {
      return (featureCodes.indexOf(item.Code) == -1 && item.ISCHECKED == true)
    });
    if (ScreenNotFeature != null && ScreenNotFeature.length == 0) {
      this.commonService.ValidationBanner("Please select Required Screens");
    }
    else {
      this.screens.forEach((item) => {
        if (item.RecordStatus == "Inactive" && item.ISCHECKED == true) {
          isInvalid = true;
        }
      });
      if (isInvalid == false) {

        this.modalRef.close(this.screens);
      }
      else {
        this.commonService.ValidationBanner("Please remove deleted/inactive screen(s) to save the details")
      }
    }

  }

  close(){
    this.canExit().then(x=>{
      this.modalRef.dismiss();
    });  }

    canExit() {
      if (this.IsDirty) {
        return this.commonService.CanDeactivateBanner();
      }
      else {
        return Promise.resolve(true);
      }
    }
}
